import { DataLabelEnum } from '../../../../model/data_label.enum';
import { GetVolProvider } from '../../../../providers/get-vol-provider';
import { VolCompareProvider } from '../../../../providers/widgets';
import { IVolatilitySmileComparisonProps } from './types';
import VolatilitySmileComparisonWidget from './volatility-smile-comparison-widget';

const VolatilitSmileComparisonWrapperProvider = (props: IVolatilitySmileComparisonProps) => {
  return (
    <GetVolProvider label={DataLabelEnum.PERPETUAL} providerKey={props.providerKey}>
      <VolCompareProvider providerKey={props.providerKey}>
        <VolatilitySmileComparisonWidget {...props} />
      </VolCompareProvider>
    </GetVolProvider>
  );
};

export default VolatilitSmileComparisonWrapperProvider;
